import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useEffect } from 'react';
import { View, Text, StyleSheet, ScrollView, Pressable } from 'react-native';
import { FormContext, ModeType, ValidateStatusType } from '..';
import { gray_1, gray_7, brand, gray_5, gray_2 } from '../../../../styles/rn';
import OrderArrowRight from '../../../../assets/images/rn/OrderArrowRight';
var styles = StyleSheet.create({
  wrapper: {
    paddingTop: 16,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 12,
    // borderBottomWidth: 1,
    borderColor: gray_7,
    borderStyle: 'solid'
  },
  contentWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  selectListWrapper: {
    flex: 1
  },
  selectListItem: {
    flex: 1,
    padding: 16,
    color: gray_1,
    borderBottomWidth: 1,
    borderColor: gray_7,
    borderStyle: 'solid'
  },
  inputErrMsgWithPadding: {
    color: brand,
    paddingLeft: 12
  },
  emptyWrapper: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 8,
    width: 350,
    borderWidth: 1,
    borderColor: gray_7,
    borderStyle: 'solid'
  },
  emptyText: {
    color: gray_5
  },
  emptyArrowIcon: {
    width: 16,
    height: 16,
    paddingLeft: 4
  },
  viewArrowIcon: {
    width: 16,
    height: 16
  },
  webformItemLabel: {
    flex: 1,
    flexDirection: 'row',
    paddingBottom: 8
  },
  webformItemRequired: {
    color: brand,
    paddingLeft: 2
  }
});
var List = function List(props) {
  var _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options;
  return /*#__PURE__*/React.createElement(ScrollView, {
    style: styles.selectListWrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.selectListWrapper
  }, options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Pressable, {
      key: index,
      onPress: function onPress() {
        var _props$onChange;
        return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, option.label);
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.selectListItem
    }, /*#__PURE__*/React.createElement(Text, null, option.label)));
  })));
};
export default (function (props) {
  var _options$find;
  var mode = props.mode,
    options = props.options;
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errMsg = _React$useState2[0],
    setErrMsg = _React$useState2[1];
  var text = options === null || options === void 0 ? void 0 : (_options$find = options.find(function (i) {
    return i.label === props.value;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label;
  var formContext = useContext(FormContext); // useEffect(() => {
  //   // TODO: 在 RN 的 tracker 写好之前，先手动触发 impression 上报
  //   // 因为 button 的 click上报和 impression 上报的字段是一样的，所以这里直接用 click 的上报数据
  //   if (Platform.OS === 'web') {
  //     props.trackingData &&
  //       dataMaintainer.tracker?.dispatchTrack({
  //         operation: TRACKING_OPERATION.IMPRESSION,
  //         section: props.trackingData.trackingsection,
  //         target: TRACKING_TARGET.webform,
  //         data: {
  //           viewed_objects: [{ ...(props.trackingData.trackingdataBasic || {}) }],
  //         },
  //       });
  //   }
  // }, []);

  useEffect(function () {
    if ((formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus) === ValidateStatusType.Validating) {
      var _formContext$handleFo;
      var res = handleValidate(props.value);
      formContext === null || formContext === void 0 ? void 0 : (_formContext$handleFo = formContext.handleFormItemValidate) === null || _formContext$handleFo === void 0 ? void 0 : _formContext$handleFo.call(formContext, _defineProperty({}, props.name, res ? res : ValidateStatusType.Success));
    }
  }, [props.value, formContext === null || formContext === void 0 ? void 0 : formContext.validateStatus]);
  var handleValidate = function handleValidate(value) {
    if (props.validator) {
      var msg = props.validator(value);
      setErrMsg(msg);
      return msg;
    } else if (props.required) {
      if (!value) {
        setErrMsg('The Field is required');
        return 'The Field is required';
      }
      setErrMsg(undefined);
    }
  };
  var handleChange = function handleChange(value) {
    var _props$onChange2;
    (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, value);
  };
  return /*#__PURE__*/React.createElement(View, null, [ModeType.EditItem].includes(mode) ? /*#__PURE__*/React.createElement(List, _extends({}, props, {
    onChange: handleChange
  })) : null, /*#__PURE__*/React.createElement(View, {
    style: [styles.wrapper, [ModeType.View, ModeType.Checking].includes(mode) ? {
      borderBottomWidth: 1
    } : {
      borderBottomWidth: 0
    }]
  }, [ModeType.Edit, ModeType.View, ModeType.Checking].includes(mode) ? /*#__PURE__*/React.createElement(View, {
    style: styles.contentWrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.webformItemLabel]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [ModeType.Edit].includes(mode) ? {
      color: gray_1
    } : {
      color: gray_2
    }
  }, props.label), props.required && [ModeType.Edit].includes(mode) ? /*#__PURE__*/React.createElement(Text, {
    style: styles.webformItemRequired
  }, "*") : null), text ? /*#__PURE__*/React.createElement(View, {
    style: {
      paddingTop: 4
    }
  }, /*#__PURE__*/React.createElement(Text, null, text)) : /*#__PURE__*/React.createElement(View, {
    style: styles.emptyWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.emptyText
  }, "Select"), /*#__PURE__*/React.createElement(OrderArrowRight, {
    style: styles.emptyArrowIcon
  }))), text && ![ModeType.View].includes(mode) ? /*#__PURE__*/React.createElement(OrderArrowRight, {
    style: styles.viewArrowIcon
  }) : null) : null, !!errMsg ? /*#__PURE__*/React.createElement(Text, {
    style: styles.inputErrMsgWithPadding
  }, errMsg) : null));
});